import Validator from 'validatorjs';

export const validate = (claimAmount, prevClaimAmount, faceValue) => {

  if (!claimAmount) {
    return undefined;
  }

  const totalClaimAmount = Number(claimAmount) + Number(prevClaimAmount);

  const fields = {
    claimAmount,
    totalClaimAmount
  };

  const rules = {
    claimAmount: [ `regex:/^\\d+(,\\d{3})*(\\.\\d*)?$` ],
    totalClaimAmount: [ `min:0.1`, `max:${faceValue}` ]
  };

  const errorMessages =  {
    'regex.claimAmount': 'Claim amount is invalid.',
    'min.totalClaimAmount': 'Claim amount must be greater than zero.',
    'max.totalClaimAmount': 'Total claim amount cannot be greater than face value.',
  };

  const validator = new Validator(fields, rules, errorMessages);
  validator.passes();

  const errors = validator.errors.all();

  // NOTE: As Redux form does not handle submission errors and field-level errors consistently,
  // convert data structure from object to array.

  if (errors.claimAmount) {
    return [ errors.claimAmount ];
  }

  if (errors.totalClaimAmount) {
    return [ errors.totalClaimAmount ];
  }

};

export const checkIfEmpty = props => {
  let rules;
  let errorMessages;

  if (!props.issue) {
    rules = {
      issue: 'required',
      message: 'required'
    };

    errorMessages = {
      'required.issue': 'Issue is required.',
      'required.message': 'Message is required.'
    };
  }

  if (props.issue && !props.message) {
    rules = { message: 'required' };

    errorMessages = { 'required.message': 'Message is required.' };
  }

  if (props.issue === 'Did not receive my card') {
    rules = {
      issue: 'required',
      message: 'required'
    };

    errorMessages = {
      'required.issue': 'Issue is required.',
      'required.message': 'Message is required.'
    };
  }

  if (props.issue === 'Other') {
    rules = {
      issue: 'required',
      subject: 'required',
      message: 'required'
    };

    errorMessages = {
      'required.issue': 'Issue is required.',
      'required.subject': 'Subject is required.',
      'required.message': 'Message is required.'
    };
  }

  if (props.issue === 'Balance discrepancy' || props.issue === 'Card missing information' || props.issue === 'Card number invalid' || props.issue === 'Not accepted by merchant') {
    rules = {
      issue: 'required',
      secondaryIssue: 'required',
      claimAmount: 'required',
      message: 'required'
    };

    errorMessages = {
      'required.issue': 'Issue is required.',
      'required.secondaryIssue': 'Please provide what\'s missing.',
      'required.claimAmount': 'Please provide amount missing from card.',
      'required.message': 'Message is required.'
    };
  }

  const validator = new Validator(props, rules, errorMessages);
  validator.passes();
  return validator.errors.all();
};
